<app-search-box></app-search-box>

<div class="mb-5 container text-center arabic-dir pt-lg-5">
  <div class="row mt-5">
    <div class="col-lg-5 m-auto text">
      <h3 class="font-weight-bold mb-4 text-primary">
        {{ "BAZZAR.SHOPS" | translate }}
      </h3>
      <p class="text">
        {{ "BAZZAR.HOME_LINE1" | translate }}
      </p>
    </div>
    <div class="col-lg-5 mx-auto">
      <div class="card rounded-lg my-2 my-md-4 mx-auto">
        <div class="row mx-0 px-0">
          <div class="col-lg-6 p-0 m-0">
            <img
              src="../../assets/pexels-ayako-suzaki-5846578.jpg"
              class="p-0 m-0"
              height="220"
              width="100%"
            />
          </div>
          <div class="col-lg-6 my-auto">
            <div class="card-body text-center">
              <h5 class="font-weight-bold">
                {{ "BAZZAR.ALL_THE_SHOPS" | translate }}
              </h5>
              <p>{{ "BAZZAR.FIND" | translate }}</p>
              <p>
                <a
                  class="btn btn-outline-primary text-primary pt-2"
                  routerLink="/all-shops"
                >
                  {{ "BAZZAR.EXPLORE" | translate }}</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="text-center justify-content-center w-100 row mx-0 my-5 py-2 py-lg-4"
  >
    <hr class="w-25" />
  </div>

  <div class="text-center">
    <div class="row card-group flex-column-reverse flex-lg-row">
      <div class="col-lg-5 mx-auto">
        <div class="card rounded-lg my-2 my-md-4 mx-auto">
          <div class="row mx-0 px-0">
            <div class="col-lg-6 p-0 m-0">
              <img
                src="../../assets/pexels-linda-ellershein-3127883.jpg"
                class="p-0 m-0"
                height="220"
                width="100%"
              />
            </div>
            <div class="col-lg-6 my-auto">
              <div class="card-body text-center">
                <h5 class="font-weight-bold">
                  {{ "BAZZAR.JOIN_TODAY" | translate }}
                </h5>
                <p>{{ "BAZZAR.BECOME" | translate }}</p>

                <a
                  class="btn btn-outline-primary text-primary pt-2"
                  routerLink="/join-us"
                  >{{ "BAZZAR.EXPLORE" | translate }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-5 m-auto">
        <h3 class="font-weight-bold mb-4 text-primary">
          {{ "BAZZAR.JOIN_US" | translate }} !!
        </h3>
        <p>
          {{ "BAZZAR.HOME_LINE2" | translate }}
        </p>
      </div>
    </div>
  </div>
</div>

<!-- footer-->
<div class="py-lg-4"></div>
